module.exports = __webpack_public_path__ + "img/lordsmobile_guide_es.ed3d72f.png";